import type { IBranchListRow } from "@/models/Branch";

export type DrawerMode = "ADD" | "EDIT" | "DETAIL";

/** What a row hands to the drawer: it loads the rest with BranchApi.get(id). */
export type BranchRecord = Pick<
  IBranchListRow,
  "id" | "refCode" | "name" | "nameEng" | "logo" | "isConfirmed" | "type" | "createdAt"
>;

export type RowActionKey = "edit" | "detail";

export function pickBranchRecord(row: IBranchListRow): BranchRecord {
  return {
    id: row.id,
    refCode: row.refCode,
    name: row.name,
    nameEng: row.nameEng,
    logo: row.logo,
    isConfirmed: row.isConfirmed,
    type: row.type,
    createdAt: row.createdAt,
  };
}

/** `?type=` value of a branch type code (HEAD_OFFICE -> head_office); the absent param means all types. */
export const branchTypeToParam = (code: string) => code.toLowerCase();

export function paramToBranchType(param: string | null, codes: string[]): string | null {
  if (!param) return null;
  return codes.find((code) => branchTypeToParam(code) === param.toLowerCase()) ?? null;
}
